const SHIJI_MAIL_PENDING_TENANT_COOKIE = "shiji_mail_pending_tenant";
const SHIJI_MAIL_AUTH_BASE =
  "https://sis.shijicloud.com/auth/realms/shiji_shijimini/protocol/openid-connect/auth";

function normalizeTenant(tenant) {
  return typeof tenant === "string" ? tenant.trim() : "";
}

function buildSisRedirectUri(identityAddress, returnUrl) {
  return encodeURIComponent(`${identityAddress}?ReturnUrl=${returnUrl}`);
}

function buildShijiMailAuthUrl({ identityAddress, returnUrl }) {
  const redirectUri = buildSisRedirectUri(identityAddress, returnUrl);

  return (
    `${SHIJI_MAIL_AUTH_BASE}?redirect_uri=${redirectUri}` +
    "&client_id=shijimail&response_type=code&login=true&scope=openid" +
    "&socialLogin=saml"
  );
}

function buildSisTokenRequest(options) {
  const shijiMailTenant = normalizeTenant(options.pendingShijiMailTenant);
  const isShijiMail = Boolean(shijiMailTenant);
  const params = {
    code: options.code,
    redirect_uri: options.redirectUri,
  };

  if (isShijiMail) {
    params.sso_tenant_name = shijiMailTenant;
  }

  return {
    isShijiMail,
    url: isShijiMail ? options.shijiMailTokenApi : options.sisTokenApi,
    params,
  };
}

function isPendingShijiMailCallback(code, pendingShijiMailTenant) {
  return Boolean(code && normalizeTenant(pendingShijiMailTenant));
}

module.exports = {
  SHIJI_MAIL_PENDING_TENANT_COOKIE,
  buildShijiMailAuthUrl,
  buildSisTokenRequest,
  isPendingShijiMailCallback,
  normalizeTenant,
};
